(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name AppController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('AppController', AppController);

    AppController.$inject = ["GenerallabService","AnalisisService","$uibModal","UserService","$timeout","$location",'$anchorScroll'];

    function AppController(GenerallabService,AnalisisService,$uibModal,UserService,$timeout,$location,$anchorScroll)
    {
        var vm = this;

        vm.info = { centros:[],usermail:true};
        vm.loadingGuardar = false;
        vm.usuario = {};
        vm.codeSave = 0;
        vm.codeGuardar = 0;
        vm.generalLab = GenerallabService;
        vm.generalLab.optionsMunicipis.ajax.data = function (params) {
            return {
              q: params.term, // search term
              page: params.page,
              lang_id: lang_id,
              provincia: vm.info.centros[0].provincia_id,
              per_page: 20
            };
        };

        vm.generalLab.optionsProvincias.ajax.data = function (params) {
            return {
              q: params.term, // search term
              page: params.page,
              lang_id: lang_id,
              pais_id: vm.info.centros[0].pais_id,
              per_page: 20
            };
        };


        vm.esMaquina = function(muestra){
           var res = false;
           //console.log(muestra.extra);
           if(typeof(muestra.extra) != 'undefined'){
               if(typeof(muestra.extra.infoMaqExt) != 'undefined'){
                   res = true;
               }

           }
           //console.log("muestra",res);
           return res;
            //muestra.extra.extra
        }

        vm.tieneMiGrupo = function(analitica,centro){
            if(centro.grupocompra && typeof(analitica.grupocompra_id) != 'undefined' && analitica.grupocompra_id){
                if(!Array.isArray(analitica.grupocompra_id)){
                    analitica.grupocompra_id = ""+analitica.grupocompra_id;
                    analitica.grupocompra_id = analitica.grupocompra_id.split(",");
                    //console.log("grupo",analitica.grupocompra_id);
                }
                return analitica.grupocompra_id.indexOf(centro.grupocompra_id);
            }
            return false;
            //return appvm.info.centros[0].grupocompra ? ' ('+appvm.info.centros[0].grupocompra.nombre+')' :'')
        }
        
        vm.asesoramientoModal = "";
        vm.asesoramiento = function(muestra){
            vm.asesoramientoModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'asesoramiento.html',
                  size: 's',
                  backdrop:'static',
                  controller: function($scope) {
                    $scope.muestra = muestra.id;
                    $scope.okForm = function(){
                        AnalisisService.guardarAsesoramiento($scope.muestra,function(data){
                            vm.asesoramientoModal.close();
                        });
                    }
                    $scope.koForm = function(){
                        vm.asesoramientoModal.close();
                    }
                   
                  }
              });
        }

        vm.modificarPerfilMod = "";

        /*vm.setHoras = function(){

            var x = 30; //minutes interval
            var times = []; // time array
            var tt = 0; // start time

            for (var i=0;tt<24*60; i++) {
              var hh = Math.floor(tt/60); 

              var mm = (tt%60); // getting minutes of the hour in 0-30 format
              times[i] = ("0" + (hh % 24)).slice(-2) + ':' + ("0" + mm).slice(-2) + [Math.floor(hh/24)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
              tt = tt + x;
              times[i]= times[i].slice(0,5);
            }

            //console.log(times);
            return times;
          }*/

          vm.openModCentro = function(){
              vm.modificarPerfilMod = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title-top',
                    ariaDescribedBy: 'modal-body-top',
                    templateUrl: 'editarperfilrec.html',
                    size: 'right-full',
                    backdrop:'static',
                    controller: function($scope) {
                        $scope.appvm = vm;
                        //$scope.horas = vm.setHoras();
                        $scope.centro = vm.info.centros[0];
                        /*UserService.getHorario(function(data){
                            $scope.centro.horario = data.horario;
                            //console.log($scope);
                        })*/
                      $scope.okForm = function(){
                          console.log("guardando cerrando2");
                          vm.guardarcentro(function(){

                              /*UserService.getHorario(function(data){
                                  $scope.centro.horario = data.horario;
                                  vm.modificarPerfilMod.close();
                                  //console.log($scope);
                              })*/
                          });
                          vm.modificarPerfilMod.close();
                          //vm.modificarPerfilMod.close();
                      }
                      $scope.koForm = function(){
                          vm.modificarPerfilMod.close();
                      }

                      $scope.horaTarde = function(horario){
                          horario.push({});
                      }
                     
                    }
                });
          }

        vm.editarPerfil = function(){
                //vm.openModCentro();
            UserService.getModificacionDatos(function(dataDatos){
              if(dataDatos.code==1){
                vm.openModCentro();
              }
            });
        }

        vm.contieneCitoBio = function(muestra,muestrasAbiertas){
            //MIRAMOS SI TIIENE CITOLOGIA O BIOPSIA
            var res = false;
            if(typeof(muestrasAbiertas)!='undefined'){
                for(var cont=0;cont<muestrasAbiertas.length && !res;cont++){
                    for(var cont2=0;cont2<muestrasAbiertas[cont].analiticas.length && !res;cont2++){
                        if((muestrasAbiertas[cont].analiticas[cont2].formulario_resultado=="Biopsia125" || muestrasAbiertas[cont].analiticas[cont2].formulario_resultado=="Citologia121") && muestra.mostrar_web==1){
                            res = true;
                        }
                    }
                }
            }
            return res;
        }

        /*vm.iniciarVariablesNombre = function(vet){
            if(typeof(vet) != undefined && vet.nombre!=''){
                //console.log(vet.nombre.split(','));
                vet.apellidos=(typeof(vet.nombre.split(',')[0]) != 'undefined' ? vet.nombre.split(',')[0].trim() : '');
                vet.nombre=(typeof(vet.nombre.split(',')[1]) != 'undefined' ? vet.nombre.split(',')[1].trim() : '');
            }
        }*/

        vm.getCentro = function(){
        	UserService.getCentroUser(function(data){

                    //vm.info.veterinarios = data.veterinariosCentros;
                    vm.info.centros = data.centros;
                    vm.info.proxFactura = data.proxFactura;
                    vm.info.recogida = data.recogida;
                    vm.info.peticiones = data.peticiones;
                    vm.generalLab.monedero = data.monedero;
                    vm.generalLab.centros = data.centros;
                    //$timeout(function(){
                  //console.log("provincia_id",vm.info.centros[0].provincia_id);
                  //console.log("nombre",vm.info.centros[0].provincia.nombre);
                  if(typeof(vm.info.centros[0].provincia)!='undefined'){
                      vm.generalLab.optionsProvincias.initSelection = function (element, callback) {
                        
                          callback({id: vm.info.centros[0].provincia_id, text: vm.info.centros[0].provincia.nombre });
                      };
                  }

                  if(typeof(vm.info.centros[0].municipio)!='undefined'){
                      vm.generalLab.optionsMunicipis.initSelection = function (element, callback) {
                        
                          callback({id: vm.info.centros[0].municipio_id, text: vm.info.centros[0].municipio.nombre });
                      };
                  }

                    /*UserService.getHorario(function(data){
                        vm.info.centros[0].horario = data.horario;
                        //console.log($scope);
                    })*/
                    vm.editarPerfil();

                        /*
                        //console.log(vm.info.centros[0]);
                        if(typeof(vm.info.centros[0].municipio)!='undefined' && vm.info.centros[0].municipio!=''){
                            //console.log(vm.info.centros[0].municipio);
                            $('#municipiocentro').select2("trigger", "select", {
                                data: { id: vm.info.centros[0].municipio, text:vm.info.centros[0].municipio }
                            });
                        }*/
                    //});
            });
        }

        vm.borrarVet = function(vet){
            vet.borrado = 1;
        	//vm.info.centros[0].veterinariosCentro.splice(index,1);
        }

        /*vm.addVet = function(){
            if(typeof(vm.info.centros[0].veterinariosCentro)=='undefined'){
                vm.info.centros[0].veterinariosCentro = [];
            }
        	vm.info.centros[0].veterinariosCentro.push({ nombre:"" , apellidos:"", email:"", limps_id_col: "" });
        }*/

        vm.guardarcentro = function(callback){
            console.log("guardando");
            vm.loadingGuardar = true;
        	UserService.guardarCentro(vm.info,function(data){
        		//console.log(data);
        		vm.loadingGuardar = false;
        		vm.editarShow = false;
        		vm.codeSave = data.code;
                vm.info.centros[0].veterinariosCentro  = data.veterinariosCentros;
                vm.modificarPerfilMod.close();
                if(typeof(callback) != 'undefined'){
                    callback();
                }
        		//vm.info.veterinarios = data.veterinariosCentros;

            });
        }

        vm.guardarUsuario = function(){
            vm.loadingGuardarAcceso = true;
            UserService.registrarCentro(vm.usuario,function(data){
                vm.loadingGuardarAcceso = false;
                vm.codeGuardar = data.code;
            });
        }
               
    }


})();